
const _typeContract = 
[
    {
        "name": "Indefinido"
    },
    {
        "name": "Por Faena"
    },
    {
        "name": "Plazo Fijo"
    }
]

export default _typeContract